import { useMemo } from 'react';
import type { Offer } from '@ooh/contracts';
import { useOffersList } from '../../offers/api/use-offers-list';
import type { QueueJoinOfferOption } from './queue-join-types';

type QueueOfferSource = Pick<Offer, 'id' | 'title' | 'clientId' | 'brand' | 'status'>;

export function mapQueueOfferOptions(offers: QueueOfferSource[]): QueueJoinOfferOption[] {
  return offers
    .filter((offer) => offer.status === 'DRAFT')
    .map((offer) => ({
      value: String(offer.id),
      label: offer.title,
      clientId: offer.clientId,
      brand: offer.brand ?? null,
    }));
}

/** Draft offers available to the optional standalone queue identity selector. */
export function useQueueOfferOptions(): QueueJoinOfferOption[] {
  const offersQuery = useOffersList('mine');
  return useMemo(() => mapQueueOfferOptions(offersQuery.data ?? []), [offersQuery.data]);
}
